import header from "./technisches-zeichnen-2.webp";
import section1 from "./technisches-zeichnen-3.jpg";
import section2 from "./arbeitsplatz-technisches-zeichnen-3.jpg";
import section3 from "./technisches-zeichnen-4.jpg";
import section4 from "./arbeitsplatz-technisches-zeichnen.jpg";
import section5 from "./arbeitsplatz-technisches-zeichnen-2.jpg";
import section6 from "./arbeitsplatz-technisches-zeichnen-4.webp";
import section7 from "./technisches-zeichnen.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
